import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef
 as MatDialogRef  } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { DeleteTransportService } from '../../service/delete-transport.service';
import { ResponseStatus } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { DictionaryKeySelectOption } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';

export interface DeleteTransportDialogData {
  transportId: number;
  carrier: string;
  identifier: string;
  name: string;
  transportScope: string;
  successCallback: () => void;
}

@Component({
  selector: 'app-delete-transport-dialog',
  templateUrl: './delete-transport-dialog.component.html',
  styleUrls: ['./delete-transport-dialog.component.scss']
})
export class DeleteTransportDialogComponent implements OnInit {

  selectedOption: DictionaryKeySelectOption;
  remark = '';
  responseMessages: ResponseMessage[];

  selectedIndex = -1;

  constructor(
    public dialogRef: MatDialogRef<DeleteTransportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteTransportDialogData,
    private deleteTransportService: DeleteTransportService,
    public translationService: TranslationService,
    public cps: ConfigurationService) {
  }

  ngOnInit() {
    console.log('property tmc-yard.cancel-transport.select-first is', this.cps.getClientParamValue('tmc-yard.cancel-transport.select-first', 'false'));
    this.selectedIndex = this.cps.getClientParamValue('tmc-yard.cancel-transport.select-first', 'false') === 'true' ? 0 : -1;
  }

  isCancelDisabled() {
    return false;
  }

  cancelDialog() {
    this.dialogRef.close();
  }

  isConfirmDisabled() {
    return !this.selectedOption;
  }

  optionsChanged(event: DictionaryKeySelectOption) {
    this.selectedOption = event;
  }

  confirm() {
    this.deleteTransportService.deleteTransport({
      remark: this.remark,
      cause: this.selectedOption.value,
      transport: { id: this.data.transportId }
    }).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {
        this.data.successCallback();
        this.dialogRef.close();
      } else {
        this.responseMessages = response.responseMessages;
      }
    }, error => {
      console.error(error);
    });
  }

}
